import { render, staticRenderFns } from "./InfoContact.vue?vue&type=template&id=242c887e&scoped=true"
import script from "./InfoContact.vue?vue&type=script&lang=js"
export * from "./InfoContact.vue?vue&type=script&lang=js"
import style0 from "./InfoContact.vue?vue&type=style&index=0&id=242c887e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c887e",
  null
  
)

export default component.exports